<template lang="html">
  <v-spacer class="spacer"/>
</template>

<script>
export default {
}
</script>

<style lang="css" scoped>
</style>
